import { createFileRoute } from '@tanstack/react-router';
import { EventsPage } from '@/modules/events/public';
import { RequirePermission, usePermissions } from '@/modules/identity/public';

export const Route = createFileRoute('/_admin/eventos/')({
  component: function EventsRoute() {
    const navigate = Route.useNavigate();
    const { can } = usePermissions();
    return (
      <RequirePermission anyOf={['eventos.ver']}>
        <EventsPage
          canEdit={can('eventos.editar')}
          onOpen={(eventId) => navigate({ to: '/eventos/$eventId', params: { eventId } })}
          onCreate={() => navigate({ to: '/eventos/novo' })}
        />
      </RequirePermission>
    );
  },
});
